export const GET_APPROVALS_REQUEST = 'GET_APPROVALS_REQUEST';
export const GET_APPROVALS_SUCCESS = 'GET_APPROVALS_SUCCESS';
export const GET_APPROVALS_FAILURE = 'GET_APPROVALS_FAILURE';
export const VIEW_REQUEST = 'VIEW_REQUEST';

